import SummaryItem from 'components/SummaryItem/SummaryItem'
import { translateManager as t } from 'services/TranslateManager'
import { formatPrice } from '../../../../../utils/utils'
import sumBy from 'lodash/sumBy'
import { type GiftCardCreditsSummaryItem } from '../../../../Pricing/types/checkout.types'

type Props = {
  giftCardCreditItems: GiftCardCreditsSummaryItem[]
  currency: string
}

function GiftCardCreditsItem({ giftCardCreditItems, currency }: Props) {
  const appliedCredits = sumBy(giftCardCreditItems, (i) => i.price)
  if (appliedCredits === 0) {
    return null
  }
  return (
    <SummaryItem
      text={t.get('order.checkout.gift_card_credits')}
      testId="gift-card-credits-summary-item"
    >
      {`${formatPrice(appliedCredits, currency)}`}
    </SummaryItem>
  )
}

export default GiftCardCreditsItem
